import SeoLandingPage from "@/components/SeoLandingPage";

const GitPracticeGame = () => <SeoLandingPage pageKey="gitPracticeGame" />;

export default GitPracticeGame;
